import { cfetch } from '@confluence/network';

type DismissCurationOptions = {
	neverShowAgain?: boolean;
	remindTomorrow?: boolean;
};

export const useDismissCuration = () => {
	const dismissAction = async ({
		neverShowAgain = false,
		remindTomorrow = false,
	}: DismissCurationOptions = {}): Promise<void> => {
		// `remindTomorrow=true` pauses the banner in any space for 24 hours (DISCO-5941).
		// It stands alone — `neverShowAgain` is only sent for the non-remind dismiss paths.
		const params = remindTomorrow
			? new URLSearchParams({ remindTomorrow: 'true' })
			: new URLSearchParams({ neverShowAgain: String(neverShowAgain) });
		await cfetch(
			`/wiki/rest/internal/1.0/spaces/remote-objects/suggestions/dismiss?${params.toString()}`,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
			},
		);
	};

	return { dismissAction };
};
